<!-- Start Login Area -->
<div class="login-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="login-form">
                <div class="logo">
                    <a routerLink="#"><img src="assets/img/fragmaq-logo-small.png" alt="image"></a>
                </div>

                <h2>Fragmaq - WMS</h2>

                <form>
                    <div class="form-group">
                        <input [ngModelOptions]="{standalone: true}" [(ngModel)]="usuarioLogin.login" type="text" class="form-control" placeholder="Login">
                        <span class="label-title"><i class='bx bx-user'></i></span>
                    </div>

                    <div class="form-group">
                        <input [ngModelOptions]="{standalone: true}" [(ngModel)]="usuarioLogin.senha" type="password" class="form-control" name="password" placeholder="Senha">
                        <span class="label-title"><i class='bx bx-lock'></i></span>
                    </div>

                    <div class="form-group">
                        <div class="remember-forgot">
                           
                            <a routerLink="" (click)="esqueciSenha()" class="forgot-password">Esqueceu a senha?</a>
                        </div>
                    </div>

                    <button type="button" (click)="login()" class="login-btn">ENTRAR</button>

                </form>
            </div>
        </div>
    </div>
</div>
<!-- End Login Area -->

<!-- Modal Recuperar Senha -->
<div class="modal fade" id="recuperarSenhaModal" tabindex="-1" aria-labelledby="recuperarSenhaModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="recuperarSenhaModalLabel">Recuperar Senha</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-group mb-3">
                        <label for="loginRecuperacao" class="form-label">Digite seu login:</label>
                        <input [(ngModel)]="loginRecuperacao" [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="loginRecuperacao" placeholder="Seu login">
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><i class='bx bx-x me-1'></i>Cancelar</button>
                <button type="button" class="btn btn-danger" (click)="recuperarSenha()" [disabled]="!loginRecuperacao || isLoading">
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {{ isLoading ? 'Enviando...' : 'Recuperar' }}
                </button>
            </div>
        </div>
    </div>
</div>